import { render, staticRenderFns } from "./online-service.vue?vue&type=template&id=f52f5d8c&"
import script from "./online-service.vue?vue&type=script&lang=js&"
export * from "./online-service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports